module.exports = __webpack_public_path__ + "static/media/euro.5c3f496c.png";